<template>
    <div class="unified-panel">
        <div class="unified-panel-header" unselectable="on">
            <div class="unified-panel-header-inner">
                <div class="panel-header-buttons">
                    <panel-view-button
                        :panel-views="panelViews"
                        :current-panel-view="currentPanelView"
                        @updatePanelView="updatePanelView"
                        v-if="panelViews && Object.keys(panelViews).length > 1"
                    />
                </div>
                <div class="panel-header-text">Tools</div>
            </div>
        </div>
        <div class="unified-panel-controls">
            <tool-search
                :current-panel-view="currentPanelView"
                placeholder="search tools"
                @onQuery="onQuery"
                @onResults="onResults"
            />
        </div>
        <div class="unified-panel-body">
            <div class="toolMenuContainer">
                <tool-section
                    v-for="category in moduleSections"
                    :hide-name="true"
                    :category="category"
                    tool-key="name"
                    :section-name="category.name"
                    :query-filter="query"
                    :disable-filter="true"
                    :key="category.name"
                    @onClick="onInsertModule"
                />
                <tool-section
                    v-if="hasDataManagerSection"
                    :category="dataManagerSection"
                    :key="dataManagerSection.id"
                    :query-filter="query"
                    :disable-filter="true"
                    @onClick="onInsertTool"
                />
                <tool-section
                    v-for="section in sections"
                    :category="section"
                    :query-filter="query"
                    :key="section.id"
                    @onClick="onInsertTool"
                />
                <tool-section
                    v-if="hasWorkflowSection"
                    :category="workflowSection"
                    :key="workflowSection.name"
                    section-name="workflows"
                    operation-icon="fa fa-files-o"
                    operation-title="Insert individual steps."
                    :query-filter="query"
                    :disable-filter="true"
                    @onClick="onInsertWorkflow"
                    @onOperation="onInsertWorkflowSteps"
                />
            </div>
        </div>
    </div>
</template>

<script>
import _l from "utils/localization";
import ToolSection from "./Common/ToolSection";
import ToolSearch from "./Common/ToolSearch";
import { filterToolSections } from "./utilities";
import PanelViewButton from "./Buttons/PanelViewButton";

export default {
    name: "ToolBox",
    components: {
        ToolSection,
        ToolSearch,
        PanelViewButton,
    },
    data() {
        return {
            query: null,
            results: null,
        };
    },
    props: {
        toolbox: {
            type: Array,
            required: true,
        },
        panelViews: {
            type: Object,
        },
        currentPanelView: {
            type: String,
        },
        workflows: {
            type: Array,
            required: true,
        },
        dataManagers: {
            type: Array,
            required: true,
        },
        moduleSections: {
            type: Array,
            required: true,
        },
    },
    computed: {
        hasWorkflowSection() {
            return this.workflows.length > 0;
        },
        workflowSection() {
            return {
                name: _l("Workflows"),
                elems: this.workflows,
            };
        },
        hasDataManagerSection() {
            return this.dataManagers.length > 0;
        },
        dataManagerSection() {
            return {
                name: _l("Data Managers"),
                elems: this.dataManagers,
            };
        },
        sections() {
            return filterToolSections(this.toolsLayout, this.results);
        },
        toolsLayout() {
            return this.toolbox.map((section) => {
                return {
                    ...section,
                    elems:
                        section.elems &&
                        section.elems.map((el) => {
                            el.disabled = !el.is_workflow_compatible;
                            return el;
                        }),
                };
            });
        },
    },
    methods: {
        onQuery(query) {
            this.query = query;
        },
        onResults(results) {
            this.results = results;
        },
        onInsertTool(tool, evt) {
            evt.preventDefault();
            this.$emit("onInsertTool", tool.id, tool.name);
        },
        onInsertModule(module, evt) {
            evt.preventDefault();
            this.$emit("onInsertModule", module.name, module.title);
        },
        onInsertWorkflow(workflow, evt) {
            evt.preventDefault();
            this.$emit("onInsertWorkflow", workflow.latest_id, workflow.name);
        },
        onInsertWorkflowSteps(workflow) {
            this.$emit("onInsertWorkflowSteps", workflow.id, workflow.step_count);
        },
        updatePanelView(panelView) {
            this.$emit("updatePanelView", panelView);
        },
    },
};
</script>
